import { HolidayStatusKind } from 'modules/holiday/utils/holidayStatus';
import React, { FunctionComponent } from 'react';
import { Label } from 'semantic-ui-react';

type Props = {
  status: HolidayStatusKind;
};

export const HolidayStatus: FunctionComponent<Props> = ({ status }) => {
  switch (status) {
    case 'upcoming':
      return <Label color="yellow">À venir</Label>;
    case 'ongoing':
      return <Label color="green">En cours</Label>;
    case 'ended':
      return <Label color="grey">Terminé</Label>;
  }
};
